// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-templates----Contact-module---wrapper---HTycq","content":"src-templates----Contact-module---content---81biz","contactForm":"src-templates----Contact-module---contactForm---1PsUj"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/Contact.module.scss
// module id = ./src/templates/Contact.module.scss
// module chunks = 186072240823722